"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductPromotionsDiscountSearchModel = instanceOfProductPromotionsDiscountSearchModel;
exports.ProductPromotionsDiscountSearchModelFromJSON = ProductPromotionsDiscountSearchModelFromJSON;
exports.ProductPromotionsDiscountSearchModelFromJSONTyped = ProductPromotionsDiscountSearchModelFromJSONTyped;
exports.ProductPromotionsDiscountSearchModelToJSON = ProductPromotionsDiscountSearchModelToJSON;
exports.ProductPromotionsDiscountSearchModelToJSONTyped = ProductPromotionsDiscountSearchModelToJSONTyped;
/**
 * Check if a given object implements the ProductPromotionsDiscountSearchModel interface.
 */
function instanceOfProductPromotionsDiscountSearchModel(value) {
    return true;
}
function ProductPromotionsDiscountSearchModelFromJSON(json) {
    return ProductPromotionsDiscountSearchModelFromJSONTyped(json, false);
}
function ProductPromotionsDiscountSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'wsppdPromotionsNo': json['wsppdPromotionsNo'] == null ? undefined : json['wsppdPromotionsNo'],
    };
}
function ProductPromotionsDiscountSearchModelToJSON(json) {
    return ProductPromotionsDiscountSearchModelToJSONTyped(json, false);
}
function ProductPromotionsDiscountSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'wsppdPromotionsNo': value['wsppdPromotionsNo'],
    };
}
